import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove } from '../../services/travel'

function* fetchTravelsRefresh() {
  const fe = JSON.parse(localStorage.getItem('fetchTravels'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_TRAVEL,
    result,
  })
}

function* fetchTravels({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = JSON.parse(localStorage.getItem('fetchTravels'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchTravels', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_TRAVEL,
    result,
  })
}

function* fetchTravelEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_TRAVEL,
    result,
  })
}

function* fetchTravelSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_TRAVEL_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_TRAVELS,
  })
}

function* fetchTravelSave2(values) {
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  const fe = JSON.parse(localStorage.getItem('fetchTravels'))
  if (fe == null) {
    fe.size = 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  const result2 = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_TRAVEL,
    result: result2,
  })
}

function* fetchTravelDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_TRAVEL_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_TRAVELS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_TRAVELS, fetchTravels),
    takeEvery(actions.FETCH_TRAVEL, fetchTravelEdit),
    takeEvery(actions.SAVE_TRAVEL, fetchTravelSave),
    takeEvery(actions.SAVE_TRAVEL2, fetchTravelSave2),
    takeEvery(actions.DELETE_TRAVEL, fetchTravelDelete),
    takeEvery(actions.RE_FETCH_TRAVELS, fetchTravelsRefresh),
  ])
}
